const CountersignatureIcon = ({ ...props }) => {
	return (
		<svg
			{...props}
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M16.5169 14.7438L16.037 13.9131M16.5169 14.7438C17.4389 16.3408 20.024 15.1197 19.1019 13.5227L14.4757 8.89639M16.5169 14.7438C17.4073 16.2861 14.7877 17.2827 13.8972 15.7404M13.8972 15.7404L13.4294 14.7438M13.8972 15.7404C14.8193 17.3374 12.7328 19.0579 11.8107 17.4609L11.3341 16.6354M11.3341 16.6354L10.5468 15.2717M11.3341 16.6354C12.2379 18.2008 9.88483 19.5594 8.98102 17.9939C8.98102 17.9939 8.98102 17.9939 7.53611 15.7404C6.09119 13.4868 4.31306 14.0055 1.99993 13.9131"
				stroke="currentColor"
				strokeWidth="1.8"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.4697 8.88632C13.8077 9.26854 12.2007 10.1186 10.5588 11.0666C8.26632 12.3902 6.67465 9.58318 8.94537 8.27218C12.485 6.22856 13.8696 2.71473 17.8199 6.08121C19.9453 7.89251 21.4148 7.73957 21.9931 7.73957"
				stroke="currentColor"
				strokeWidth="1.8"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}

export default CountersignatureIcon
